import React from 'react'
import BadgeUI from '../../../widgets/output/BadgeUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import LinkWithSpinnerUI from '../../../widgets/action/LinkWithSpinnerUI'
import LoanListNav2UI from '../../../components/superUser/loanList/LoanListNav2UI'
import CopyToClipboardUI from '../../../widgets/output/CopyToClipboardUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SearchUI from '../../../widgets/input/SearchUI'
import './LoanList.css'

const LoanListUI = ({ context, loanList, openOrClosed, response,
  onRowClick, onRefreshClick, onCopyToClipboard, copyToClipboardText,
  searchFilter, onSearchFilterChange, onDownloadClick, downloadSubmitted, fundSourceList,
}) =>
  <div className='su_loan_lst'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          onRefreshClick={onRefreshClick}
        />
      }
      right={
        <ActionRightUI
          context={context}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
        />
      }
    />
    <div className='g_flex_h'>
      <span />
      <span className='g_small g_muted'>Search by account name, loan status or underwriter</span>
    </div>

    <LoanListNav2UI page={openOrClosed} />

    <div className='g_flex_h g_m_bottom_50'>
      <span>{loanList.length} loan{loanList.length == 1 ? '' : 's'} displayed</span>
      <div className='g_flex_h g_flex_right'>
        <span>
          {fundSourceList && fundSourceList.map((item, i) => (
            <BadgeUI key={i} className='g_m_left_50' label={`${item.key}: ${item.value}`} />
          ))}
        </span>

        <LinkWithSpinnerUI
          label='Download Loan Tape'
          onClick={onDownloadClick}
          busy={downloadSubmitted}
          spinnerOnLeft={true}
        />
      </div>
    </div>

    <LRTableBodyUI>
      {
        loanList.map((loan, i) =>
          <LoanRowUI i={i} key={i} context={context} loan={loan} onRowClick={onRowClick}
            onCopyToClipboard={onCopyToClipboard}
            copyToClipboardText={copyToClipboardText}
          />
        )
      }
    </LRTableBodyUI>
  </div>

const LoanRowUI = ({ i, context, loan, onRowClick, onCopyToClipboard, copyToClipboardText }) =>
  <LRTableRowUI
    context={context} className='g_flex_top'
    left={
      <RowLeftUI i={i} context={context} loan={loan}
        onCopyToClipboard={onCopyToClipboard}
        copyToClipboardText={copyToClipboardText}
      />
    }
    right={<RowRightUI loan={loan} />}
    onClick={onRowClick}
    rowId={loan.loanId}
  />

const RowLeftUI = ({ i, context, loan, onCopyToClipboard, copyToClipboardText }) =>
  <div className='g_flex_h g_flex_top left2'>
    <span>
      <b>{i + 1}</b>
    </span>
    <div className='g_flex_v g_m_left_50'>
      <div>
        <b>{loan.accountName}</b>
        {
          loan.businessName &&
          <span> ({loan.businessName})</span>
        }
        <span className='g_m_left_100'>{loan.loanName}</span>
        <span className='g_m_left_100'><i>{loan.loanTypeLabel}</i></span>
        {
          loan.loanSubType &&
          <span className='g_m_left_100'><i>{loan.loanSubType}</i></span>
        }
        <span className='g_m_left_100'><i>{loan.appFlavor}</i></span>
        <span className='g_m_left_100'><i>{loan.purpose}</i></span>
        {
          loan.capex &&
          <span className='g_m_left_100'><i>capex</i></span>
        }
        {
          loan.fundSource &&
          <span className='g_m_left_100'><i>{loan.fundSource}</i></span>
        }
        <div className='g_muted g_flex_h g_flex_left'>
        <span className='g_m_right_100'>{loan.parentLRN ? loan.parentLRN + ' > ' + loan.loanRefNum : loan.loanRefNum}</span>
          <CopyToClipboardUI text={loan.loanId}
            onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
          />
        </div>
      </div>

      {/*
          loan.status !== 'disbursed' && loan.status !== 'closed' &&
          <StepProgressBarUI
            values={['requested', 'term_sheet', 'sanctioned', 'disbursed', 'closed']}
            selected={loan.status}
          />
        */}
      <div className='g_m_top_50 g_flex_h g_flex_left'>
        Requested: {loan.loanRequest.dateF1}
        <span className='g_m_left_100'>{loan.assignedUserName}</span>
        <span className='g_m_left_100'>{loan.loanRequest.loanPurpose}</span>
        <span className='g_m_left_100 g_info2'><b>{loan.interestYearDays}</b></span>
      </div>
    </div>
  </div>

const RowRightUI = ({ loan }) =>
  <div className='g_flex_v right g_text_right'>
    {
      loan.subStatus &&
      <div>
        <BadgeUI label={loan.subStatus} />
      </div>
    }
    {
      loan.status == 'requested' &&
      <div className='g_flex_v g_m_top_50'>
        <span>{loan.loanRequest.amountF2}</span>
        <span>{loan.loanRequest.tenureMonths} months</span>
        <span className='g_no_wrap'>{loan.loanRequest.dateF1}</span>
      </div>
    }
    {
      loan.status == 'term_sheet' &&
      <div className='g_flex_v g_m_top_50'>
        <span>{loan.termSheet.amountF2}</span>
        <span>{loan.termSheet.tenureMonths} months</span>
        <span>{loan.termSheet.interestRate}% p.a.</span>
        <span className='g_no_wrap'>{loan.termSheet.dateF1}</span>
      </div>
    }
    {
      loan.status == 'sanctioned' &&
      <div className='g_flex_v g_m_top_50'>
        <span>{loan.sanction.amountF2}</span>
        <span>{loan.sanction.tenureMonths} months</span>
        <span className='g_no_wrap'>{loan.sanction.dateF1}</span>
      </div>
    }
    {
      loan.status == 'disbursed' &&
      <div className='g_text_right g_m_top_50 g_flex_v'>
        <b>Disbursed</b>
        <span className='g_no_wrap'>{loan.disbursement.amountF2}</span>
        <span className='g_no_wrap'>{loan.termSheet.tenureMonths} months</span>
        {
          loan.termSheet.interestMonths &&
          <span className='g_no_wrap'>Interest only: <br />{loan.termSheet.interestMonths} months</span>
        }
        <span className='g_no_wrap'>{loan.termSheet.interestRate}% p.a.</span>
        <span className='g_no_wrap'>{loan.disbursement.dateF1}</span>
        {
          loan.loanType === 'inv_discount' && loan.closedDateF &&
          <span className='g_small g_info'>Closed: {loan.closedDateF}</span>
        }
      </div>
    }
    {/*
      loan.status == 'disbursed' && loan.disbursementList.length !== 0 &&
      <div className='g_text_right g_m_top_50'>
        <b>Disbursed</b>
        {
          loan.disbursementList.map((disbursement, i) =>
            <div className='g_flex_v' key={i}>
              <span className='g_no_wrap'>{disbursement.amountF2}</span>
              <span className='g_no_wrap'>{disbursement.dateF1}</span>
            </div>
          )
        }
        {
          loan.loanType === 'inv_discount' && loan.closedDateF &&
          <span className='g_small g_info'>Closed: {loan.closedDateF}</span>
        }
      </div>
    */}
    {
      loan.status === 'closed' &&
      <div className='g_m_top_50 g_text_right'>
        {loan.closedDateF}
      </div>
    }
  </div>

const ActionLeftUI = ({ onRefreshClick }) =>
  <div className='g_flex_h'>
    <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
    <span className='g_m_left_100 g_large'><b>Loans</b></span>
  </div>

const ActionRightUI = ({ searchFilter, onSearchFilterChange }) =>
  <SearchUI value={searchFilter} onChange={onSearchFilterChange} />

export default LoanListUI
